import { GetterTree } from "vuex";
import { IRootState } from "@/store/types";
import { IUserProfileState } from ".";
import { IUser } from "@/models/user";

export const getters: GetterTree<IUserProfileState, IRootState> = {
    userInfo(state): IUser | null {
        return state.userInfo;
    },
    isAuthenticated(state): boolean | null {
        return state.isAutehnticated;
    },
    userError(state): any {
        return state.error;
    },
};
